import * as React from 'react';
import cx from 'classnames';
import { DatasheetHolderProps, useDatasheetHolderController } from './datasheet-holder.controller';

import './datasheet-holder.styles.scss';

export const DatasheetHolder: React.FC<DatasheetHolderProps> = (props) => {
  const { children, style, className, reference, selectionDisabled, printableDatasheetHolderId } = props;
  
  const { isSelecting, selectionBox, handleMouseDown, handleMouseMove, handleMouseUp } = useDatasheetHolderController(props);

  return (
    <div 
      id={printableDatasheetHolderId}
      style={style}
      className={cx("DatasheetsEditorDatasheetHolder", className)}
      ref={reference}
      onMouseDown={selectionDisabled ? undefined : handleMouseDown}
      onMouseMove={selectionDisabled 
        ? undefined 
        : isSelecting ? handleMouseMove : undefined}
      onMouseUp={selectionDisabled ? undefined : handleMouseUp}
    >
      {children}
      {isSelecting && selectionBox && (
        <div
          className="DatasheetsEditorDatasheetHolder__selection-box"
          style={{
            top: selectionBox.y,
            left: selectionBox.x,
            width: selectionBox.width,
            height: selectionBox.height,
          }}
        />
      )}
    </div>
  );
};